import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  TemplateRef,
  OnDestroy
} from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { PnrrService } from "../../../services/pnrr.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { KeyValue } from 'src/app/models/keyValue';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { NgxDatatableWrapperComponent } from 'src/app/components/_components/ngxDatatableWrapper/ngx-datatable-wrapper.component';
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: "pnrr-missione-management",
    templateUrl: "./pnrr-missione-management.component.html",
    styleUrls: ["./pnrr-missione-management.component.css"]
})
export class PnrrMissioneManagementComponent
    implements OnInit, OnDestroy {
    visible = true;
    continents: KeyValue[];
    continentsAdd: KeyValue[];
    submitted: boolean = false;
    addMissionForm: FormGroup;
    modalRef: BsModalRef = null;
    open: boolean = false;
    dtOptionsNgx: any;

    @ViewChild('templateEditAdd', { static: true })
    public templateEditAdd: TemplateRef<any>;
    @ViewChild('templateModal', { static: true })
    public templateModal: TemplateRef<any>;
    @ViewChild('saveBtn', {static: false})
    public saveBtn: ElementRef;

    //@ViewChild('buttonsTemplate',{static:false}) buttonsTemplate: TemplateRef<any>;
    @ViewChild('btnEditTemplate', { static: true })
    public btnEditTemplate: TemplateRef<any>;

    @ViewChild('btnDeleteTemplate', { static: true })
    public btnDeleteTemplate: TemplateRef<any>;

    @ViewChild('ngxDatatableWrapper')
    ngxDatatableWrapper: NgxDatatableWrapperComponent;
    templateList = [];

    section: string = 'PNRR - Missioni';

    config = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: "modal-lg"
    };

    constructor(
        private http: HttpClient,
        private pnrrService: PnrrService,
        private formBuilder: FormBuilder,
        private localeService: BsLocaleService,
        private el: ElementRef,
        private toastr: ToastService,
        private modalService: BsModalService,
        private authService:AuthService
    ) {
        this.localeService.use("it");
        this.dtOptionsNgx = {
            rows: []
            , totalElements: 0
            , columns: this.columns
            , columnMode: ColumnMode.flex
            , headerHeight: "50"
            , footerHeight: "50"
            , rowHeight: "auto"
            , externalSorting: true// true
            , loadingIndicator: 'loading'
            , class: "bootstrap"
            , summaryRow: true
            , summaryPosition: "'bottom'"
            , externalPaging: true// true
            , count: 0
            , offset: 0
            , limit: 10
            , serverSide: true
            , ajax: this.loadData
            , scrollbarH: "true"
        };
    }

    refreshGrid() {
        this.ngxDatatableWrapper.refresh();
    }

    ngOnDestroy(): void {

    }
    ngOnInit() {
        window.scroll(0, 0);
        this.addMissionForm = this.initializeFormGroup();
        this.templateList = [{ name: 'btnDeleteTemplate', template: this.btnDeleteTemplate }, { name: 'btnEditTemplate', template: this.btnEditTemplate }];
    }


    initializeFormGroup() {
        return this.formBuilder.group({
            id: [null],
            descrizione: [
                null,
                [Validators.required, Validators.maxLength(255)]
            ],
            codice: [
                null,
                [Validators.required]
            ]
        });
    }

    get f() {
        return this.addMissionForm.controls;
    }

    onSubmit() {
        this.submitted = true;
        this.addMissionForm.updateValueAndValidity();

        let errors = false;
        for (let c in this.f) {
            errors = errors || this.f[c].errors !== null;
            console.log(
                "this.f[" + c + "].errors:" + JSON.stringify(this.f[c].errors)
            );
        }
        if (this.addMissionForm.invalid || errors) {
            console.log("invalid");
            let invalidElements = []; // this.el.nativeElement.querySelectorAll('.is-invalid');
            for (let el in this.addMissionForm.controls) {
                if (this.addMissionForm.controls[el].invalid) {
                    console.log(`set focus on ${el}`);
                    if (this.addMissionForm.controls[el] instanceof FormGroup) {
                        for (let el1 in this.addMissionForm.get(el)["controls"]) {
                            if (this.addMissionForm.get(el)["controls"][el1].invalid) {
                                invalidElements = this.el.nativeElement.querySelectorAll(
                                    `[formcontrolname="${el1}"]`
                                );
                                break;
                            }
                        }
                    } else {
                        invalidElements = this.el.nativeElement.querySelectorAll(
                            `[formcontrolname="${el}"]`
                        );
                    }
                    break;
                }
            }
            if (invalidElements.length > 0) {
                invalidElements[0].focus();
            }

            return false;
        }

        const obj = this.addMissionForm.value;

        this.pnrrService.saveMissione(obj).subscribe(res => {
            this.toastr.success("Missione salvata con successo!");
            this.refreshGrid();
            this.submitted = false;
            this.open = false;
            this.closeModal();
        }, error => {
            this.toastr.error("Codice già presente");
        })
    }

    columns = [
        {
            name: 'id', prop: 'id', visible: false, sortable: true, filtrable: true, width: 10
            , resizeable: false
        }
        , {
            name: 'codice'
            , prop: 'codice'

            , sortable: true
            , filtrable: true
            , resizeable: false
            , draggable: false
            , flexGrow: 2
            , minWidth: 60
        },
        {
            name: 'descrizione'
            , prop: 'descrizione'
            , sortable: true
            , filtrable: true
            , resizeable: false
            , draggable: false
            , flexGrow: 3
            , minWidth: 100
        }
        , {
            name: 'modifica'
            , prop: null
            , visible: this.checkPermission('update')
            , sortable: false
            , filtrable: false
            , cellTemplate: 'btnEditTemplate'// 'buttonsTemplate'
            //, width: 10
            , resizeable: false
            , draggable: false
            , flexGrow: 1
            , minWidth: 50
        }
        , {
            name: 'elimina'
            , prop: 'id'
            , visible: this.checkPermission('delete')
            , sortable: false
            , filtrable: false
            , cellTemplate: 'btnDeleteTemplate'// 'buttonsTemplate'
            , flexGrow: 1
            , minWidth: 60
        }
    ];

    loadData = (dataTablesParameters: any, callback: any) => {
        this.pnrrService.getAllMissioneDt(dataTablesParameters)
            .subscribe(resp => {
                callback(resp);
            });
    };


    onEdit(row) {
        this.submitted = false;
        //console.log(row);
        this.modalRef = this.modalService.show(this.templateModal, this.config);
        this.addMissionForm.setValue({
            id: row.id,
            descrizione: row.descrizione,
            codice: row.codice
        });
        if (this.checkPermission('update')) {
            this.addMissionForm.controls.codice.enable();
            this.addMissionForm.controls.descrizione.enable();
            this.saveBtn.nativeElement.disabled = false;
        } else {
            this.addMissionForm.controls.codice.disable();
            this.addMissionForm.controls.descrizione.disable();
            this.saveBtn.nativeElement.disabled = true;
        }
    }
    loading: boolean = false;
    onDelete(row) {
        console.log(row);
        if (!confirm(`Stai per eliminare la missione "${row.descrizione}", proseguire?`)) return;
        this.loading = true;
        this.pnrrService.deleteMissione(row.id).subscribe(
            result => {
                this.loading = false;
                this.refreshGrid();
                this.toastr.success('Missione eliminata con successo', null, {
                    timeOut: 2000,/*closeButton:true,*/ disableTimeOut: false
                });
            }
            , error => {
                this.loading = false;
                this.toastr.error(`Impossibile eliminare la missione: ${error.error.message ? error.error.message : (error.error.error_description ? error.error.error_description : error.error)}`, null, {
                    timeOut: 2000,/*closeButton:true,*/ disableTimeOut: false
                });
                console.log('error');
            });
    }
    closeModal() {
        if (this.modalRef)this.modalRef.hide();
        this.addMissionForm.reset();

        if (this.checkPermission('insert')) {
            this.addMissionForm.controls.codice.enable();
            this.addMissionForm.controls.descrizione.enable();
            this.saveBtn.nativeElement.disabled = false;
        } else {
            this.addMissionForm.controls.codice.disable();
            this.addMissionForm.controls.descrizione.disable();
            this.saveBtn.nativeElement.disabled = true;
        }
    }
    isAdmin(){
        //return true;//con la nuova gestione permessi e menu, sapendo che il gruppo pnrr deve accedere a questa sezione, non posso piu gestire isAdmin
        return this.authService.isAdmin();
    }

    /**
     * Controlla se l'utente può accedere o meno alla sezione.
     * @param section il nome della sezione
     * @param operations le operazioni da poter effettuare sulla sezione
     * @param atLeastOne opzionale. Se true almeno un'operazione deve essere contenuta nei permessi, tutte altrimenti. Ha valore false di default
     * @param enableOnNotFound opzionale. Se true (default) e non esiste la sezione settata nei permessi, ritorna true, false altrimenti
     * @returns true se il controllo è andato a buon fine, false altrimenti
    */
     enableSection(section: string, operations: string[], atLeastOne: boolean = false, enableOnNotFound: boolean = true): boolean {
      return this.authService.checkPermissionBySectionAndOperations(section, operations, atLeastOne, enableOnNotFound);
    }

    checkPermission(operation: string) {
      return (!this.isAdmin() && this.enableSection(this.section, [operation], false, false)) || (this.isAdmin() && this.enableSection(this.section, [operation]));
    }
}
